export var NK = [
    // 0-16
    {
        NK: {
            '0': 257.42,
            '300': 259.51,
            '600': 205.64,
            '1200': 128.47,
            '3000': 80.74,
        },
    },
    // 17-20
    {
        NK: {
            '0': 326.57,
            '300': 310.94,
            '600': 272,
            '1200': 235.04,
            '3000': 120.52,
        },
    },
    // 21
    {
        NK: {
            '0': 507.09,
            '300': 520.75,
            '600': 454.32,
            '1200': 364.89,
            '3000': 247.6,
        },
    },
    // 22
    {
        NK: {
            '0': 515.8,
            '300': 530.06,
            '600': 463.28,
            '1200': 372.61,
            '3000': 253.36,
        },
    },
    // 23
    {
        NK: {
            '0': 524.47,
            '300': 539.35,
            '600': 472.19,
            '1200': 380.32,
            '3000': 259.15,
        },
    },
    // 24
    {
        NK: {
            '0': 532.95,
            '300': 548.44,
            '600': 480.93,
            '1200': 387.88,
            '3000': 264.88,
        },
    },
    // 25
    {
        NK: {
            '0': 541.5,
            '300': 557.73,
            '600': 489.7,
            '1200': 395.52,
            '3000': 270.68,
        },
    },
    // 26
    {
        NK: {
            '0': 550.03,
            '300': 567.04,
            '600': 498.45,
            '1200': 403.13,
            '3000': 276.5,
        },
    },
    // 27
    {
        NK: {
            '0': 558.59,
            '300': 576.4,
            '600': 507.22,
            '1200': 410.78,
            '3000': 282.38,
        },
    },
    // 28
    {
        NK: {
            '0': 567.27,
            '300': 585.96,
            '600': 516.1,
            '1200': 418.54,
            '3000': 288.36,
        },
    },
    // 29
    {
        NK: {
            '0': 576.08,
            '300': 595.67,
            '600': 525.1,
            '1200': 426.42,
            '3000': 294.46,
        },
    },
    // 30
    {
        NK: {
            '0': 584.82,
            '300': 605.31,
            '600': 534.04,
            '1200': 434.26,
            '3000': 300.6,
        },
    },
    // 31
    {
        NK: {
            '0': 593.52,
            '300': 614.9,
            '600': 542.91,
            '1200': 442.11,
            '3000': 306.83,
        },
    },
    // 32
    {
        NK: {
            '0': 602.23,
            '300': 624.52,
            '600': 551.8,
            '1200': 450.01,
            '3000': 313.17,
        },
    },
    // 33
    {
        NK: {
            '0': 611.13,
            '300': 634.36,
            '600': 560.88,
            '1200': 458.09,
            '3000': 319.68,
        },
    },
    // 34
    {
        NK: {
            '0': 620.42,
            '300': 644.67,
            '600': 570.35,
            '1200': 466.53,
            '3000': 326.45,
        },
    },
    // 35
    {
        NK: {
            '0': 629.95,
            '300': 655.24,
            '600': 580.07,
            '1200': 475.21,
            '3000': 333.46,
        },
    },
    // 36
    {
        NK: {
            '0': 639.9,
            '300': 666.25,
            '600': 590.2,
            '1200': 484.27,
            '3000': 340.77,
        },
    },
    // 37
    {
        NK: {
            '0': 650.29,
            '300': 677.79,
            '600': 600.8,
            '1200': 493.76,
            '3000': 348.42,
        },
    },
    // 38
    {
        NK: {
            '0': 661.2,
            '300': 689.93,
            '600': 611.92,
            '1200': 503.73,
            '3000': 356.42,
        },
    },
    // 39
    {
        NK: {
            '0': 672.92,
            '300': 702.96,
            '600': 623.86,
            '1200': 514.38,
            '3000': 364.9,
        },
    },
    // 40
    {
        NK: {
            '0': 685.02,
            '300': 716.45,
            '600': 636.2,
            '1200': 525.44,
            '3000': 373.74,
        },
    },
    // 41
    {
        NK: {
            '0': 697.56,
            '300': 730.39,
            '600': 648.98,
            '1200': 536.9,
            '3000': 382.97,
        },
    },
    // 42
    {
        NK: {
            '0': 710.53,
            '300': 744.77,
            '600': 662.2,
            '1200': 548.77,
            '3000': 392.58,
        },
    },
    // 43
    {
        NK: {
            '0': 723.97,
            '300': 759.61,
            '600': 675.9,
            '1200': 561.08,
            '3000': 402.56,
        },
    },
    // 44
    {
        NK: {
            '0': 737.88,
            '300': 774.89,
            '600': 690.08,
            '1200': 573.81,
            '3000': 412.91,
        },
    },
    // 45
    {
        NK: {
            '0': 752.32,
            '300': 790.69,
            '600': 704.79,
            '1200': 587.09,
            '3000': 423.7,
        },
    },
    // 46
    {
        NK: {
            '0': 767.17,
            '300': 806.83,
            '600': 719.93,
            '1200': 600.8,
            '3000': 434.84,
        },
    },
    // 47
    {
        NK: {
            '0': 782.51,
            '300': 823.4,
            '600': 735.56,
            '1200': 615,
            '3000': 446.39,
        },
    },
    // 48
    {
        NK: {
            '0': 798.41,
            '300': 840.44,
            '600': 751.77,
            '1200': 629.75,
            '3000': 458.41,
        },
    },
    // 49
    {
        NK: {
            '0': 814.68,
            '300': 857.79,
            '600': 768.36,
            '1200': 644.88,
            '3000': 470.8,
        },
    },
    // 50
    {
        NK: {
            '0': 831.52,
            '300': 875.65,
            '600': 785.52,
            '1200': 660.54,
            '3000': 483.7,
        },
    },
    // 51
    {
        NK: {
            '0': 848.76,
            '300': 893.89,
            '600': 803.09,
            '1200': 676.62,
            '3000': 497.04,
        },
    },
    // 52
    {
        NK: {
            '0': 866.41,
            '300': 912.52,
            '600': 821.07,
            '1200': 693.13,
            '3000': 510.86,
        },
    },
    // 53
    {
        NK: {
            '0': 884.45,
            '300': 931.5,
            '600': 839.46,
            '1200': 710.04,
            '3000': 525.18,
        },
    },
    // 54
    {
        NK: {
            '0': 902.88,
            '300': 950.87,
            '600': 858.24,
            '1200': 727.36,
            '3000': 540.02,
        },
    },
    // 55
    {
        NK: {
            '0': 921.91,
            '300': 970.84,
            '600': 877.63,
            '1200': 745.25,
            '3000': 555.48,
        },
    },
    // 56
    {
        NK: {
            '0': 941.46,
            '300': 991.24,
            '600': 897.55,
            '1200': 763.65,
            '3000': 571.53,
        },
    },
    // 57
    {
        NK: {
            '0': 961.52,
            '300': 1012.14,
            '600': 917.99,
            '1200': 782.58,
            '3000': 588.19,
        },
    },
    // 58
    {
        NK: {
            '0': 982.23,
            '300': 1033.65,
            '600': 939.09,
            '1200': 802.16,
            '3000': 605.6,
        },
    },
    // 59
    {
        NK: {
            '0': 1003.53,
            '300': 1055.73,
            '600': 960.79,
            '1200': 822.3,
            '3000': 623.71,
        },
    },
    // 60
    {
        NK: {
            '0': 1025.45,
            '300': 1078.37,
            '600': 983.11,
            '1200': 843.1,
            '3000': 642.65,
        },
    },
    // 61
    {
        NK: {
            '0': 1047.85,
            '300': 1101.56,
            '600': 1005.92,
            '1200': 864.48,
            '3000': 662.37,
        },
    },
    // 62
    {
        NK: {
            '0': 1070.61,
            '300': 1125.07,
            '600': 1029.09,
            '1200': 886.32,
            '3000': 682.9,
        },
    },
    // 63
    {
        NK: {
            '0': 1093.5,
            '300': 1148.69,
            '600': 1052.39,
            '1200': 908.52,
            '3000': 704.16,
        },
    },
    // 64
    {
        NK: {
            '0': 1116.54,
            '300': 1172.38,
            '600': 1075.85,
            '1200': 930.95,
            '3000': 726.23,
        },
    },
    // 65
    {
        NK: {
            '0': 1137.9,
            '300': 1194.28,
            '600': 1097.64,
            '1200': 951.94,
            '3000': 747.26,
        },
    },
    // 66
    {
        NK: {
            '0': 1159.17,
            '300': 1215.92,
            '600': 1119.35,
            '1200': 972.88,
            '3000': 768.2,
        },
    },
    // 67
    {
        NK: {
            '0': 1180.28,
            '300': 1237.21,
            '600': 1140.88,
            '1200': 993.73,
            '3000': 789.06,
        },
    },
    // 68
    {
        NK: {
            '0': 1201.11,
            '300': 1258.12,
            '600': 1162.14,
            '1200': 1014.39,
            '3000': 809.79,
        },
    },
    // 69
    {
        NK: {
            '0': 1221.58,
            '300': 1278.45,
            '600': 1183.03,
            '1200': 1034.75,
            '3000': 830.37,
        },
    },
    // 70
    {
        NK: {
            '0': 1241.62,
            '300': 1298.23,
            '600': 1203.48,
            '1200': 1054.75,
            '3000': 850.68,
        },
    },
];
